angular.module('impactx.dialog').controller('DialogPanelCtrl', [
    'config',
    'DialogPanelService',
    DialogPanelController]);

function DialogPanelController(config, DialogPanelService) {
    var self = this;
    self.closePanel = DialogPanelService.closePanel;

    if (config.controllerAs) {
        config.controller = config.controller + ' as ' + config.controllerAs;
    }
}